import seo from '~/marketplace-front-core/middleware/seo'

export default seo
